import { render, staticRenderFns } from "./SingleGeneExpression.vue?vue&type=template&id=6f3ba80e&scoped=true"
import script from "./SingleGeneExpression.vue?vue&type=script&lang=js"
export * from "./SingleGeneExpression.vue?vue&type=script&lang=js"
import style0 from "./SingleGeneExpression.vue?vue&type=style&index=0&id=6f3ba80e&prod&scoped=true&lang=css"
import style1 from "./SingleGeneExpression.vue?vue&type=style&index=1&id=6f3ba80e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3ba80e",
  null
  
)

export default component.exports